<template>
  <svg :width="width" :height="height" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 8V14.3705L13.9529 12.8227L13.7394 12.7143H13.5H9H4.83755L2.85604 11.2046L1 9.79044V6.85714V3.92385L2.85604 2.50972L4.83755 1H9H13.1256L16.7518 4.15749L17 4.40961V8Z" stroke="#006EFF" stroke-width="2"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 18 },
        height: { type: [Number, String], default: 16 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
